import React from 'react'

import Image from '../../Image'

import {
  compareFeature,
  infoBlock,
  imgLogo
} from './ComparisonFeatures.module.css'

const ComparisonFeatures = ({ data }) => (
  <section className={`${compareFeature}`}>
    <div className='landing-container max-w-6xl mx-auto px-6 lg:px-3 text-center items-center'>
      <h2 className='w-full landing-section-title'>{data?.title} </h2>
      <div className='grid md:grid-cols-3 md:gap-8 lg:gap-12 gap-6 w-full'>
        {data?.icon_with_text_and_content_items?.map((value, key) => (
          <div key={key} className={`${infoBlock} text-center items-center`}>
            <div className={`${imgLogo} `}>
              <Image url={value?.icon?.asset?.url} classes='mx-auto' />
            </div>
            <h3>{value?.title}</h3>
            <p>{value?.content[0]?.children[0]?.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
)
export default ComparisonFeatures
